export default "__VITE_ASSET__DKydlR0c__"